<script>
import ComunicadoForm from './ModalAdd.vue';

export default {
  name: 'ModalAtualizarComunicado',
  components: { ComunicadoForm },
  inheritAttrs: false,
};
</script>

<template>
  <comunicado-form v-bind="$attrs" v-on="$listeners" />
</template>